<template>
  <div>
    <v-dialog v-model="isOpen"
      persistent
      scrollable
      fullscreen
      content-class="image-browser">
      <v-card>
        <v-toolbar 
          class="escalon-dialog-header" 
          height="35"
          :style="borderStyle">
          <img
            class="modal-axis-logo mr-2"
            :src="require('../../assets/' + coloredLogo)" />
          <span>Placeholder</span>
          <v-spacer />
          <close-button @click="clearPlaceholderContext" />
        </v-toolbar>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// imports
import { mapGetters, mapMutations } from "vuex";
import closeButton from "../controls/CloseButton";

// exports
export default {
  name: "PlaceholderBrowser",
  components: { closeButton },
  computed: {
    ...mapGetters(["placeholderContext", "isIE", "patient", "patients"]),
    isOpen() {
      return !!this.placeholderContext;
    },
    bodyComponent() {
      return (
        (this.placeholderContext && this.placeholderContext.componentName) ||
        "placeholderBrowser"
      );
    }
  },
  methods: {
    ...mapMutations(["clearPlaceholderContext"])
  }
};
</script>